//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'
import { OpDataType } from '../core/op-data-type'
import { OpDataTypeFormat } from '../core/op-data-type-format'

export class OpDataFormatGroupDetails implements IOpChangeState, IReferenceType, IJsonSerializable {
    public idDataFormatGroup: number
    public idDataType: number
    public idDataTypeFormatIn: number
    public idDataTypeFormatOut: number
    public idUnitIn: number
    public idUnitOut: number

    private _dataType: OpDataType
    public get dataType(): OpDataType {
        return this._dataType
    }
    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value ? value.idDataType : null
    }

    private _dataTypeFormatOut: OpDataTypeFormat
    public get dataTypeFormatOut(): OpDataTypeFormat {
        return this._dataTypeFormatOut
    }
    public set dataTypeFormatOut(value: OpDataTypeFormat) {
        this._dataTypeFormatOut = value
        this.idDataTypeFormatOut = value ? value.idDataTypeFormat : null
    }

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDataFormatGroupDetails
    }
    public getReferenceKey(): number {
        return CommonHelper.getHashCode(this.idDataFormatGroup.toString() + "_" + this.idDataType.toString())
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDataFormatGroupDetails[]): JQueryPromise<OpDataFormatGroupDetails[]> {
        var defered = $.Deferred<OpDataFormatGroupDetails[]>()
        if (dataProvider && list && list.length > 0) {
            var idDataType: number[] = CommonHelper.distinct<number>(list.map(d => d.idDataType))
            var idDataTypeFormat: number[] = CommonHelper.distinct<number>(list.map(d => d.idDataTypeFormatOut))
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType, Enums.ReferenceType.IdDataTypeFormat]).then(dict => {
                var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                var dataTypeFormatDict: Dictionary<OpDataTypeFormat> = new Dictionary<OpDataTypeFormat>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType))
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                if (dict.containsKey(Enums.ReferenceType.IdDataTypeFormat))
                    dataTypeFormatDict = <Dictionary<OpDataTypeFormat>>dict.tryGetValue(Enums.ReferenceType.IdDataTypeFormat)

                list.forEach(item => {
                    item.dataType = dataTypeDict.tryGetValue(item.idDataType)
                    item.dataTypeFormatOut = dataTypeFormatDict.tryGetValue(item.idDataTypeFormatOut)
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }
        return defered.promise()
    }

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idDataFormatGroup = opObj.ID_DATA_FORMAT_GROUP
            this.idDataType = opObj.ID_DATA_TYPE
            this.idDataTypeFormatOut = opObj.ID_DATA_TYPE_FORMAT_OUT
            this.idDataTypeFormatIn = opObj.ID_DATA_TYPE_FORMAT_IN
            this.idUnitIn = opObj.ID_UNIT_IN
            this.idUnitOut = opObj.ID_UNIT_OUT
            this.opState = opObj.OpState

            this.dataType = opObj._DataType ? new OpDataType(opObj._DataType) : null
            this.dataTypeFormatOut = opObj._DataTypeFormatOut ? new OpDataTypeFormat(opObj._DataTypeFormatOut) : null
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_DATA_FORMAT_GROUP: this.idDataFormatGroup,
            ID_DATA_TYPE: this.idDataType,
            ID_DATA_TYPE_FORMAT_IN: this.idDataTypeFormatIn,
            ID_DATA_TYPE_FORMAT_OUT: this.idDataTypeFormatOut,
            ID_UNIT_IN: this.idUnitIn,
            ID_UNIT_OUT: this.idUnitOut,

            OpState: this.opState
        }
    }

    public toString(): string {
        return "DataFormatGroupDetails [" + this.idDataFormatGroup + "]"
    }

}